import { z } from 'zod';

export type UploadResource = z.infer<typeof uploadResourceSchema>;

export const uploadResourceSchema = z.object({
  /** The type of the resource */
  type: z.enum(['acceleration', 'gyro', 'video']),
  /** The bucket where the resource is stored in / should be stored in */
  bucket: z.string(),
  /** The key of the resource in the bucket */
  key: z.string(),
});

export type Upload = z.infer<typeof uploadSchema>;

/**
 * An upload is a collection of resources that are uploaded to a storage provider
 */
export const uploadSchema = z.object({
  /**
   * The id of the upload session.
   * Not to be confused with the sessionId identifying a session entity.
   */
  sessionId: z.string(),

  /** The resources of the upload */
  resources: z.array(uploadResourceSchema),
});
